import resetPasswordTemplate from './reset-password.tpl.html';
import './reset-password.less';
import { legalLinksComponentModule } from '../../components/legal-links/legal-links';
import { appConfig } from '../../constants/app-config';
import { uiRouterStateModule } from '../../vendor/ui-router-module';
import { accountServiceModule } from '../../services/account-service/account-service';
import { serverValidationErrorsComponentModule } from '../../components/forms/server-validation-errors/server-validation-errors';
import { validationMatchComponentModule } from '../../vendor/validation-match-component-module';

export const resetPasswordRouteModule = angular
  .module('Q.routes.reset-password', [
    uiRouterStateModule,
    accountServiceModule,
    validationMatchComponentModule,
    serverValidationErrorsComponentModule,
    legalLinksComponentModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('reset-password', {
      url: '/reset-password/:token?url&stateName&params',
      params: {
        url: null,
        stateName: null,
        params: null,
      },
      template: resetPasswordTemplate,
      data: {
        pageTitle: 'Reset Your Password',
        bodyClass: 'reset-password',
      },
      resolve: {
        accountServiceCheck: /* @ngInject */ function (accountService) {
          return accountService.whenReady();
        },
      },
      controllerAs: 'resetPassword',
      controller: /* @ngInject */ function (
        $state,
        $stateParams,
        $location,
        accountService,
        serverValidationService,
        $q,
      ) {
        // always logout on this page, to avoid potential errors.
        accountService.logout({ showLoadingPanel: false, reload: false });

        let ctrl = this;
        ctrl.password = '';
        ctrl.confirmPassword = '';
        ctrl.rememberMe = false;

        ctrl.submit = function () {
          ctrl.disabled = true;

          return accountService
            .resetPassword($stateParams.token, ctrl.password, {
              rememberMe: ctrl.rememberMe,
            })
            .then((account) => {
              if (!account) {
                return $q.reject({ status: 403 });
              } else {
                if ($stateParams.url) {
                  $location.url($stateParams.url).replace();
                } else if ($stateParams.stateName) {
                  $state.go($stateParams.stateName, $stateParams.params || {}, {
                    location: 'replace',
                  });
                } else {
                  $location.url(appConfig.defaultRouteUrl || '/').replace();
                }
              }
            })

            .then(
              serverValidationService.clearErrors,
              serverValidationService.getErrorHandler({
                ignoredCodes: [403, 404, 423],
              }),
            )
            .catch((resp) => {
              if (resp && resp.status) {
                if (resp.status === 403 || resp.status === 404) {
                  serverValidationService.setErrors(
                    'The reset password token has expired.  Please try again.',
                  );
                } else if (resp.status === 423) {
                  serverValidationService.setErrors(
                    'This account is inactive, unable to reset password.',
                  );
                }
              } else if (!resp) {
                serverValidationService.setErrors(
                  'An error has occurred that we were not able to recover from.  Please try again.',
                );
              }
            })

            .finally(() => (ctrl.disabled = false));
        };
      },
    });
  });
